<template>
  <el-date-picker
    v-bind="$attrs"
    v-on="$listeners"
    :value-format="$attrs.valueFormat || $attrs['value-format'] || 'yyyy-MM-dd'"
    :picker-options="pickerOptions"
    type="daterange"
    :start-placeholder="$attrs.startPlaceholder || $attrs['start-placeholder'] || '开始日期'"
    :end-placeholder="$attrs.endPlaceholder || $attrs['end-placeholder'] || '结束日期'"
  ></el-date-picker>
</template>

<script>
export default {
  name: 'ShDateRangePicker',
  mounted() {
    console.log(this.$attrs)
  },
  computed: {
    pickerOptions() {
      if (this.$attrs.pickerOptions === undefined && this.$attrs['picker-options'] === undefined) return {}
      return (
        this.$attrs.pickerOptions ||
        this.$attrs['picker-options'] || {
          shortcuts: [
            {
              text: '最近两天',
              onClick(picker) {
                const startDate = new Date()
                const endDate = new Date()
                startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 2)
                endDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [startDate, endDate])
              }
            },
            {
              text: '最近七天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                endDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                endDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                endDate.setTime(endDate.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [start, end])
              }
            }
          ]
        }
      )
    }
  }
}
</script>

<style></style>
